import styled from "styled-components";
import { HelperStyle, Cont, MainCont as SharedMainCont, BarCont, BgBar, FormContainer, ButtonsRow, FlowInfoBanner, ServerWarningBanner } from "@/screen/Identities/Styles/IdentityFormStyles";
export { HelperStyle, Cont, BarCont, BgBar, FormContainer, ButtonsRow, FlowInfoBanner, ServerWarningBanner };

export const MainCont = styled(SharedMainCont)`
    padding: 0px 10px 10px 10px;

    @media screen and (max-width: 599px)
    {
        padding: 0px 10px 10px 10px;
    }

    @media screen and (max-width: 420px)
    {
        padding: 0px 10px 10px 10px;
    }
`;

export const Title = styled.div`
    margin-top: 10px;
    cursor: default;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 12px;

    h1
    {
        font-size: 30px;
        color: #2a4143;
        font-weight: 800;
        margin: 0;
        width: auto;
        flex: 0 0 auto;
    }

    h2
    {
        font-size: 24px;
        font-weight: 400;
        color: #5f7172;
        line-height: 1.2;
        margin: 0;
        display: inline-block;
        width: auto;
        flex: 0 1 auto;
    }
`;

export const ContractHtmlContainer = styled.div`
    border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
    border-radius: 8px;
    padding: 24px;
    max-height: 80vh;
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: ${(props) => props.theme?.palette?.white ?? "#ffffff"};
    color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    font-size: 14px;
    line-height: 1.6;

    h1, h2, h3, h4
    {
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    }

    table
    {
        width: 100%;
        border-collapse: collapse;
    }

    td, th
    {
        border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
        padding: 6px 10px;
        text-align: left;
    }
`;

export const KycBlockingContainer = styled.div`
    margin-bottom: 16px;
    padding: 16px 20px;
    border-radius: 4px;
    border-left: 4px solid #f57c00;
    background-color: rgba(255, 152, 0, 0.10);
    color: #e65100;
    cursor: default;

    h3
    {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.4;
        margin: 0 0 12px 0;
    }

    ul
    {
        margin: 0;
        padding-left: 20px;
        list-style-type: disc;
    }

    li
    {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 6px;

        &:last-child
        {
            margin-bottom: 0;
        }
    }
`;

export const IntegrationPendingBanner = styled.div`
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 8px;
    padding: 16px 20px;
    margin-top: 20px;

    p
    {
        font-size: 14px;
        color: #856404;
        line-height: 1.5;
        margin: 0;
    }
`;